module.exports = __webpack_public_path__ + "img/stars-bg-mobile.51adff0.png";